// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { PhoneDirectoryItem_abstract } from './../abstract/SagaSchema/PhoneDirectoryItem_abstract';
export class PhoneDirectoryItem extends PhoneDirectoryItem_abstract {}
